import { fetchFastApi } from "../../api/fastapi";
import { useHookCacheQuery } from "../../lib/hookCache";
import {
  CellCitationDetail,
  cellCitationDetailSchema,
} from "../../models/audit/workpaperData";

/**
 * Workpaper-lazy-load: per-cell citation lazy-fetch hook for
 * `GET /controls/v2/procedure-session/{ps_id}/source-row/{sr_id}/support-cell/{support_column_id}/citations`.
 *
 * Cache key `["procedure-session", psId, "support-cell-citations", srId,
 * supportColumnId]`. The slim `useWorkpaperData` payload no longer ships
 * `citations[]` on each cell-value entry; the citation viewer (matching the
 * `05-detail-citation-panel.png` screenshot) reads from this hook on click
 * via `CitationDetailHydrator`.
 */
export function useCellCitationDetail(
  procedureSessionId: string | undefined,
  sourceRowId: string | undefined,
  supportColumnId: string | undefined | null,
) {
  return useHookCacheQuery<CellCitationDetail>({
    key: [
      "procedure-session",
      procedureSessionId ?? "",
      "support-cell-citations",
      sourceRowId ?? "",
      supportColumnId ?? "",
    ],
    fetcher: async () => {
      const response = await fetchFastApi({
        method: "GET",
        path: `/controls/v2/procedure-session/${procedureSessionId}/source-row/${sourceRowId}/support-cell/${supportColumnId}/citations`,
      });
      return cellCitationDetailSchema.parse(response);
    },
    enabled: !!procedureSessionId && !!sourceRowId && !!supportColumnId,
  });
}
